import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import * as React from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {useEffect} from "react";

export default function Q0({name, surname, setName, setSurname, yourRank, setYourRank}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="mason-question">
      <FormControl style={{display: "block"}}>
        <Grid container spacing={2} style={{marginBottom: '10px'}}>
          <Grid item xs={6}>
            <TextField
              label={`Your First Name`}
              variant="outlined"
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={{ backgroundColor: 'white' }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label={`Your Surname`}
              variant="outlined"
              fullWidth
              value={surname}
              onChange={(e) => setSurname(e.target.value)}
              style={{ backgroundColor: 'white' }}
            />
          </Grid>
        </Grid>
        <br/>
        <Grid>
          <Grid item xs={12}>
            <TextField
              label={`Your Rank`}
              variant="outlined"
              fullWidth
              value={yourRank}
              onChange={(e) => setYourRank(e.target.value)}
              style={{ backgroundColor: 'white' }}
            />
          </Grid>
        </Grid>
      </FormControl>
    </div>
  )
}